import styled from '@emotion/styled';
import {
  Category,
  Breakpoint,
  ACCESSORY_CATEGORY_GROUP,
  ACCESSORY_SUBCATEGORY_GROUP,
  BACKGROUND_CATEGORY_GROUP,
} from 'shared/types';
import {
  lighterGray,
  lightGray,
  purple,
  transparent,
} from 'shared/styles/colors';
import { media } from '@mverissimoo/emotion-grid';
import { useState, useEffect } from 'react';
import { RubikBold } from 'shared/components/Text';

interface Props {
  selectedCategory: Category;
  setSelectedCategory: (selectedCategory: Category) => void;
}

interface SubcategoryTextProps {
  isSelected: boolean;
}

const SubcategoryPicker = ({
  selectedCategory,
  setSelectedCategory,
}: Props) => {
  const [subcategories, setSubcategories] = useState<Category[]>();

  useEffect(() => {
    // Show eyewear by default when tapping accessory category
    if (selectedCategory === Category.ACCESSORIES) {
      setSelectedCategory(Category.ACCESSORIES_EYEWEAR);
    }

    if (ACCESSORY_CATEGORY_GROUP.includes(selectedCategory)) {
      setSubcategories(ACCESSORY_SUBCATEGORY_GROUP);
    }

    if (BACKGROUND_CATEGORY_GROUP.includes(selectedCategory)) {
      setSubcategories(BACKGROUND_CATEGORY_GROUP);
    }
  }, [selectedCategory]);

  return (
    <OuterContainer>
      <CategoryListContainer>
        {subcategories?.map((item) => {
          return (
            <SubcategoryWrapper onClick={() => setSelectedCategory(item)}>
              <SubcategoryTextItem isSelected={item === selectedCategory}>
                {item}
              </SubcategoryTextItem>
            </SubcategoryWrapper>
          );
        })}
      </CategoryListContainer>
    </OuterContainer>
  );
};

export default SubcategoryPicker;

const OuterContainer = styled.div({
  flex: 1,
});

const CategoryListContainer = styled.div({
  display: 'flex',
  flexWrap: 'nowrap',
  backgroundColor: lighterGray,
  justifyContent: 'space-evenly',
  alignItems: 'center',
  paddingLeft: 4,
  paddingRight: 4,
  [media(Breakpoint.lg)]: {
    height: '100%',
  },
});

const SubcategoryWrapper = styled.button({
  height: 32,
  borderWidth: 0,
  backgroundColor: transparent,
  padding: 0,
  [media(Breakpoint.lg)]: {
    height: 42,
  },
});

const SubcategoryTextItem = styled.span<SubcategoryTextProps>(
  ({ isSelected }) => [
    RubikBold,
    {
      color: isSelected ? purple : lightGray,
      alignItems: 'center',
      fontSize: 18,
      display: 'flex',
      [media(Breakpoint.lg)]: {
        display: 'flex',
      },
    },
  ],
);
